export default function getResource(label) {
    const resources = {
        saveContinueButton: 'Enregistrer et continuer'
    };

    return resources[label];
}
